<template>
  <section class="product">
    {{account}}
    <van-button @click="onPay"
                style="margin:100px">测试</van-button>
  </section>
</template>

<script>
export default {
  name: "Home",
  data () {
    return {
      active: 2,
      order: "233",
      str: []
    };
  },
  components: {},
  mounted: function () {
    // this.fetchProduct();
  },
  computed: {
    orders () {
      return this.$store.state.product.order;
    },
    account () {
      return this.$store.state.account.user;
    }
  },
  methods: {
    onPay () {
      let params = {
        ordersn: '201908191045045755',
        buyer_id: this.account.userName
      };
      console.log(params)
      this.$store
        .dispatch("alipay/fetchAlipayMini", { params })
        .then(() => {
          console.log(this.$store.state.alipay)
          my.tradePay({
            tradeNO: this.$store.state.alipay.alipaymini.trade_no,
            success: (res) => {
              my.alert({
                content: JSON.stringify(res),
              });
            },
            fail: (res) => {
              my.alert({
                content: JSON.stringify(res),
              });
            }
          });
        });
    }
  },
  created () {
    // this.fetchProduct();
  }
};
</script>
<style>
</style>
